// extracted by mini-css-extract-plugin
export default {"price":"OrderDetails_price__bhfcD"};